import { Camera2D } from "../../engine/camera/Camera2D";
import { Region, ScreenPoint } from "../types";

export class GeoHitTest {
  findRegionAt(
    ctx: CanvasRenderingContext2D,
    screenPoint: ScreenPoint,
    camera: Camera2D,
    regions: Region[],
    options?: {
      smallAreaThreshold?: number;
      slopRadius?: number;
    },
  ): Region | null {
    const world = camera.screenToWorld(screenPoint);
    const smallAreaThreshold = options?.smallAreaThreshold ?? 25;
    const slopRadius = options?.slopRadius ?? 6;
    const slopRadiusSq = slopRadius * slopRadius;
    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    for (const region of regions) {
      const { minX, minY, maxX, maxY } = region.bbox;
      if (
        world.x < minX ||
        world.x > maxX ||
        world.y < minY ||
        world.y > maxY
      ) {
        continue;
      }
      const area = Math.max(0, maxX - minX) * Math.max(0, maxY - minY);
      if (area < smallAreaThreshold) {
        const dx = world.x - region.centroid[0];
        const dy = world.y - region.centroid[1];
        if (dx * dx + dy * dy <= slopRadiusSq) {
          ctx.restore();
          return region;
        }
      }
      if (ctx.isPointInPath(region.path, world.x, world.y)) {
        ctx.restore();
        return region;
      }
    }

    ctx.restore();
    return null;
  }
}
